var React = require('react');

function LinkedInIcon3 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"2","fill":"#111111","key":0}),React.createElement("path",{"d":"M24 8H8C6.9 8 6 8.9 6 10V22C6 23.1 6.9 24 8 24H24C25.1 24 26 23.1 26 22V10C26 8.9 25.1 8 24 8ZM23.6 12.25L17.06 16.34C16.41 16.75 15.59 16.75 14.94 16.34L8.4 12.25C8.15 12.09 8 11.82 8 11.53C8 10.86 8.73 10.46 9.3 10.81L16 15L22.7 10.81C23.27 10.46 24 10.86 24 11.53C24 11.82 23.85 12.09 23.6 12.25Z","fill":"white","key":1})]);
}

LinkedInIcon3.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = LinkedInIcon3;

LinkedInIcon3.default = LinkedInIcon3;
